var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.4517C18.6274 24.4517 24 19.0791 24 12.4517C24 5.82424 18.6274 0.45166 12 0.45166C5.37258 0.45166 0 5.82424 0 12.4517C0 19.0791 5.37258 24.4517 12 24.4517Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.4517C23.9997 5.82429 18.627 0.45166 11.9997 0.45166C9.65216 0.45166 7.46244 1.12643 5.61284 2.29155L8.24314 3.4091L4.69531 4.9165L8.24314 6.42386L4.69531 7.93118L8.24314 9.43844L4.69531 10.9455L8.24314 12.4525L4.69531 13.9598L8.24314 15.467L4.69531 16.9741L8.24314 18.4813L4.69531 19.9886L8.24314 21.4957L5.61402 22.6127C7.46337 23.7772 9.65262 24.4517 11.9997 24.4517C18.627 24.4517 23.9997 19.079 23.9997 12.4517Z",
    fill: "#751A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/Qatar.70dfd4ce61674545aff49f59707ce0d8.svg";
export { ForwardRef as ReactComponent };